 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import ALST from '@/components/alst'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED835 from '@/components/Untitled835'
 import UNTITLED836 from '@/components/Untitled836'
 import UNTITLED837 from '@/components/Untitled837'
 import UNTITLED838 from '@/components/Untitled838'
 import UNTITLED839 from '@/components/Untitled839'
 import UNTITLED840 from '@/components/Untitled840'
 import UNTITLED841 from '@/components/Untitled841'
 import UNTITLED842 from '@/components/Untitled842'
 import UNTITLED843 from '@/components/Untitled843'
 import UNTITLED844 from '@/components/Untitled844'
 import UNTITLED845 from '@/components/Untitled845'
 import UNTITLED846 from '@/components/Untitled846'
 import UNTITLED847 from '@/components/Untitled847'
 import UNTITLED848 from '@/components/Untitled848'
 import UNTITLED849 from '@/components/Untitled849'
 import UNTITLED850 from '@/components/Untitled850'
 import UNTITLED851 from '@/components/Untitled851'
 import UNTITLED852 from '@/components/Untitled852'
 import UNTITLED853 from '@/components/Untitled853'
 import UNTITLED854 from '@/components/Untitled854'
 import UNTITLED855 from '@/components/Untitled855'
 import UNTITLED856 from '@/components/Untitled856'
 import UNTITLED857 from '@/components/Untitled857'
 import UNTITLED858 from '@/components/Untitled858'
 import UNTITLED859 from '@/components/Untitled859'
 import UNTITLED860 from '@/components/Untitled860'
 import UNTITLED861 from '@/components/Untitled861'
 import UNTITLED862 from '@/components/Untitled862'
 import UNTITLED863 from '@/components/Untitled863'
 import UNTITLED864 from '@/components/Untitled864'
 import UNTITLED865 from '@/components/Untitled865'
 import UNTITLED866 from '@/components/Untitled866'
 import UNTITLED867 from '@/components/Untitled867'
 import UNTITLED868 from '@/components/Untitled868'
 import UNTITLED869 from '@/components/Untitled869'
 import UNTITLED870 from '@/components/Untitled870'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/alst",
 			"name" : "alst",
 			"component" : ALST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled835",
 			"name" : "Untitled835",
 			"component" : UNTITLED835
 		},
 		{
 			"path" : "/Untitled836",
 			"name" : "Untitled836",
 			"component" : UNTITLED836
 		},
 		{
 			"path" : "/Untitled837",
 			"name" : "Untitled837",
 			"component" : UNTITLED837
 		},
 		{
 			"path" : "/Untitled838",
 			"name" : "Untitled838",
 			"component" : UNTITLED838
 		},
 		{
 			"path" : "/Untitled839",
 			"name" : "Untitled839",
 			"component" : UNTITLED839
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js